import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    const _this = this
    _this.scrollTop = document.documentElement.scrollTop

    document.addEventListener('scroll', function() {
      _this.scrollTop = document.documentElement.scrollTop

      if (_this.scrollTop > 1) {
        _this.formTarget.removeAttribute("aria-hidden")
        _this.element.classList.add("is-scrolled")
      }
      else {
        _this.formTarget.setAttribute("aria-hidden", "true")
        _this.element.classList.remove("is-scrolled")
      }
    })
  }
}
